import { render, staticRenderFns } from "./UploadManagement.vue?vue&type=template&id=6cc45a49&"
import script from "./UploadManagement.vue?vue&type=script&lang=js&"
export * from "./UploadManagement.vue?vue&type=script&lang=js&"
import style0 from "./UploadManagement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports